import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useApp } from '@/contexts/AppContext';
import SectionHeroCard from '@/components/SectionHeroCard';

export default function HomeJourneyCard() {
  const { user } = useApp();
  const [billCount, setBillCount] = useState(0);
  const [hasHomeProfile, setHasHomeProfile] = useState<boolean | null>(null);
  const [openMaintenanceCount, setOpenMaintenanceCount] = useState(0);

  useEffect(() => {
    if (!user) return;

    async function fetchJourneyState() {
      const [billRes, homeProfileRes, maintenanceRes] = await Promise.all([
        supabase.from('home_bill_settings').select('id', { count: 'exact', head: true }).eq('user_id', user.id).eq('enabled', true),
        supabase.from('home_profiles').select('id, address').eq('user_id', user.id).limit(1).maybeSingle(),
        supabase
          .from('home_maintenance_items' as any)
          .select('id', { count: 'exact', head: true })
          .eq('user_id', user.id)
          .neq('status', 'done'),
      ]);

      setBillCount(billRes.count || 0);
      setHasHomeProfile(Boolean(homeProfileRes.data?.id && homeProfileRes.data?.address));
      setOpenMaintenanceCount(maintenanceRes.count || 0);
    }

    void fetchJourneyState();

    const handleRefresh = () => {
      void fetchJourneyState();
    };

    window.addEventListener('adulting:data-changed', handleRefresh);
    return () => window.removeEventListener('adulting:data-changed', handleRefresh);
  }, [user]);

  return (
    <SectionHeroCard
      title="My Home"
      subtitle="Know what I have, what's coming up, and what to do"
      stats={[
        {
          label: 'Profile',
          value: hasHomeProfile ? 'Ready' : 'Add',
          tone: hasHomeProfile ? 'success' : 'danger',
        },
        {
          label: 'Bills',
          value: String(billCount),
          tone: billCount > 0 ? 'accent' : 'default',
        },
        {
          label: 'Repairs',
          value: String(openMaintenanceCount),
          tone: openMaintenanceCount > 0 ? 'danger' : 'success',
        },
      ]}
    />
  );
}
